/** Punto junto al título WA: amarillo = enviado, rojo = recibido. */
export function colorPuntoWaHistorial(tipo) {
  const t = String(tipo || "").toLowerCase();
  if (t === "whatsapp_enviado") return "#eab308";
  if (["whatsapp_recibido", "whatsapp_respuesta", "whatsapp_lead"].includes(t)) return "#ef4444";
  return null;
}

export function PuntoWaHistorial({ tipo }) {
  const color = colorPuntoWaHistorial(tipo);
  if (!color) return null;
  return (
    <span
      aria-hidden
      style={{
        display: "inline-block",
        width: "0.78em",
        height: "0.78em",
        borderRadius: "50%",
        background: color,
        flexShrink: 0,
        boxShadow: "0 0 0 1px rgba(0,0,0,0.08)",
      }}
    />
  );
}
